// extracted by mini-css-extract-plugin
export var noListPage = "no-list-page_KFWHLIF20UVYI82jNDVP";